<template>
  <section class="task-wrap" :style="dBHeight">
    <modals-container @dialogConfirm="getSiteList" />
    <div class="tab_ty1">
      <AuditTab :currentTab="1" />
      <div class="tab-content">
        <!-- 이력 Tab -->
        <div>
          <div class="tab_ty2">
            <AuditSubTab :currentTab="1" :currentTab2="2" />
            <div class="tab-content">
              <div>
                <div class="tb-list_ty1 audit001">
                  <div class="tb-header clear">
                    <div class="tb_num fl">
                      <div class="num" v-html="$i18nUtil.trans('search.000','총 {cnt}건',{cnt:totalCount})">
                      </div>
                    </div>

                    <div class="btnDiv">
                      <button
                        v-if="siteList.length != 0"
                        type="button"
                        class="btn-primary-small"
                        @click="sharAndCfrcSetting"
                      >
                        {{$i18nUtil.trans("message.SharAndCfrcSetting.002","회의협의체 관리")}}
                      </button>
                      <button
                        v-if="siteList.length == 0"
                        type="button"
                        class="btn-primary-small"
                        @click="createdNewSite"
                      >
                        {{$i18nUtil.trans("message.NewSite.001","신규 사이트 생성")}}
                      </button>
                      <button
                        v-else
                        type="button"
                        class="btn-primary-small"
                        @click="createdSiteAlert"
                      >
                        {{$i18nUtil.trans("message.CfrcSiteList.001","사이트 추가")}}
                      </button>
                    </div>
                  </div>
                  <!-- //tb-header -->

                  <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="siteList"
                    hide-default-footer
                    class="tb-contents"
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td>
                          {{ item.siteId }}
                        </td>

                        <td>
                          {{ (item.siteMaxSize / 1024 / 1024).toFixed(1) }}MB
                        </td>
                        <td>
                          {{ (item.siteUseSize / 1024 / 1024).toFixed(1) }}MB
                        </td>
                        <td>
                          {{ $moment(item.regDate).format("YYYY.MM.DD") }}
                        </td>
                        <td>
                          <input
                            type="checkbox"
                            name="currentActiveYn"
                            :id="item.cogroupSiteMapId"
                            :checked="item.currentActiveYn == 1"
                          />
                          <label
                            :for="item.cogroupSiteMapId"
                            class="ty2"
                            @click="updateCurrentActiveYn(item)"
                          ></label>
                        </td>
                      </tr>
                    </template>
                    <template slot="no-data">
                      <div class="nodata-txt-noicon">
                        <v-alert :value="true"> {{$i18nUtil.trans("message.CfrcSiteList.002","사이트가 없습니다.")}} </v-alert>
                      </div>
                    </template>
                  </v-data-table>

                  <div v-show="pageCount > 0" class="pagination">
                    <v-pagination
                      v-model="page"
                      circle
                      :length="pageCount"
                      :total-visible="7"
                      @input="getSiteList"
                    ></v-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import Datepicker from "vuejs-datepicker";
import AuditSubTab from "./AuditSubTab";
import AuditTab from "./AuditTab";
import NewSite from "./modal/NewSite";
import SharAndCfrcSetting from "./modal/SharAndCfrcSetting";
export default {
  components: {
    Datepicker,
    AuditSubTab,
    AuditTab,
  },
  data() {
    return {
      dBHeight: {
        "min-height": window.innerHeight - 151 + "px",
      },
      groupInfo: {},
      enabled: true,
      show: false,
      page: 1,
      pageCount: 1,
      totalCount: 0,
      itemsPerPage: 10,
      singleSelect: false,
      selected: [],
      headers: [
        {
          text: this.$i18nUtil.trans("message.CfrcSiteList.003","사이트 아이디"),
          value: "siteId",
          align: "center",
          sortable: false,
        },
        { text: this.$i18nUtil.trans("message.CfrcSiteList.004","공간용량"), value: "siteMaxSize", sortable: false },
        { text: this.$i18nUtil.trans("message.CfrcSiteList.005","활성화여부"), value: "currentActiveYn", sortable: false },
        { text: this.$i18nUtil.trans("message.CfrcSiteList.006","등록일"), value: "regDate", sortable: false },
        { text: this.$i18nUtil.trans("message.CfrcSiteList.007","현재사용용량"), value: "setting", sortable: false },
      ],
      siteList: [],
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
    };
  },
  created() {
    this.getSiteList();
  },

  methods: {
    ...mapActions("modals", ["showModal", "showToast"]),
    /* 공통 AXIOS 호출하여 통신 (restAction.js) */
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    /* 파일다운로드이력 목록 조회 */
    getSiteList() {
      let obj = this;

      let reqData = {};
      reqData.params = {
        currentPage: obj.page.toString(),
        itemsPerPage: obj.itemsPerPage.toString(),
        groupKbn: "CFRC",
        // startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
        // endDate: obj.$moment(this.endDate).format("YYYY.MM.DD"),
        searchGroup: obj.searchGroup,
      };
      reqData.url = "/api/cogroup/cogroup/getSharAndCfrcSiteByTenantId";
      reqData.method = "post";

      //프로그레스바 시작
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          this.hideLoadingbar();
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            obj.siteList = res.result.siteList;
            obj.totalCount = res.result.siteCount;
            obj.pageCount = res.result.sitePageCount;
            obj.groupInfo = res.result.groupInfo;
            // obj.totalCount % 10 == 0
            //   ? obj.totalCount / 10
            //   : Math.floor(obj.totalCount / 10 + 1);
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    createdNewSite() {
      const modalInfo = {
        obj: this.$modal,
        component: NewSite,
        width: "660px",
        groupKbn: "CFRC",
      };
      this.showModal(modalInfo);
    },
    createdSiteAlert() {
      const obj = this;
      obj.showConfirmDialog(
        { width: "400px" },
        obj.$i18nUtil.trans("title.dialog.notice","알림"),
        obj.$i18nUtil.trans("message.CfrcSiteList.008","사이트를 생성하시겠습니까?"),
        obj.$i18nUtil.trans("message.CfrcSiteList.009","생성"),
        obj.createdSite,
        null,
        obj.$i18nUtil.trans("button.dialog.no","아니오"),
        null
      );
    },
    createdSite() {
      let obj = this;

      let reqData = {};
      reqData.params = {
        groupKbn: "CFRC",
      };
      reqData.url = "/api/cogroup/cogroup/createdSharePointSite";
      reqData.method = "post";

      //프로그레스바 시작
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          //프로그레스바 종료
          this.hideLoadingbar();
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            const modalInfo = {
              title: obj.$i18nUtil.trans("title.Noti.001","알림"),
              width: "400px",
              obj: this.$modal,
              contents: obj.$i18nUtil.trans("message.CfrcSiteList.010","사이트 생성 요청이 완료되었습니다. 잠시 후 다시 확인해 주세요."),
              button: obj.$i18nUtil.trans("button.confirm","확인"),
              component: Dialog,
            };
            this.showModal(modalInfo);
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    updateCurrentActiveYn(item) {
      let obj = this;

      let reqData = {};
      reqData.params = {
        groupId: item.groupId,
        siteId: item.siteId,
      };
      reqData.url = "/api/cogroup/cogroup/updateCogroupSiteMap";
      reqData.method = "post";

      //프로그레스바 시작
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          //프로그레스바 종료
          this.hideLoadingbar();
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            obj.toastInfo.message = obj.$i18nUtil.trans("message.CfrcSiteList.011","기본 사이트가 변경되었습니다.");
            obj.showToast(obj.toastInfo);
            obj.getSiteList();
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    sharAndCfrcSetting() {
      const modalInfo = {
        obj: this.$modal,
        component: SharAndCfrcSetting,
        width: "1220px",
        height: "665px",
        groupId: this.groupInfo.groupId,
        groupKbn: this.groupInfo.groupKbn,
      };
      this.showModal(modalInfo);
    },
  },
};
</script>

<style scoped>
.tb-header > .btnDiv {
  float: right;
}
.audit001 {
  margin-top: 38px;
}
.audit001 >>> th:nth-child(1),
.audit001 >>> td:nth-child(1) {
  padding-left: 25px;
  width: calc(100% - 550px) !important;
  text-align: left;
}
.audit001 >>> th:nth-child(2),
.audit001 >>> td:nth-child(2) {
  width: 100px !important;
  text-align: center;
}
.audit001 >>> th:nth-child(3),
.audit001 >>> td:nth-child(3) {
  width: 100px !important;
  text-align: center;
}
.audit001 >>> th:nth-child(4),
.audit001 >>> td:nth-child(4) {
  width: 100px !important;
  text-align: center;
}
.audit001 >>> th:nth-child(5),
.audit001 >>> td:nth-child(5) {
  width: 100px !important;
  text-align: center;
}
.audit001 >>> th:nth-child(6),
.audit001 >>> td:nth-child(6) {
  width: 150px !important;
  text-align: center;
}
.audit001 >>> th.text-center {
  text-align: center;
}
.audit001 >>> input {
  background-color: transparent;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/CfrcSiteList.vue